import { AiOutlineClose } from "react-icons/ai";
function No() {
  return <AiOutlineClose className="text-red-900 text-xl" />;
}

export default No;
